import { render, staticRenderFns } from "./MagazzinoArticoliViewComponent.vue?vue&type=template&id=fe65912a"
import script from "./MagazzinoArticoliViewComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliViewComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliViewComponent.vue?vue&type=style&index=0&id=fe65912a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports